import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { formatDistance, subDays, format } from "date-fns";

//components
import { Curve, DoneIconNew } from "../../../components/svgs";
import {
  CurveHolder,
  StyledText,
  Button,
  MainHolder,
} from "../../../components/common/basic";

// theme
import { useTheme, useLoyalty } from "../../../hooks";
import { BackButton, FeatureHeader } from "../../../components/common";
const cinemas = { accra: "Accra" };
const DishrackRedemptionHome = () => {
  const { themeContext, theme } = useTheme();
  const [alert, setAlert] = useState(false);
  const [location, setLocation] = useState(null);
  const [redeemPage, setRedeemPage] = useState(false);
  const [code, setCode] = useState("");
  const {
    selectedLoyaltyData,
    redeemDishrackTicket,
    setDishrackRedemptionsStatus,
    dishrackRedemptionStatus,
    fetchDishrackRedemptionHistory,
    dishrackRedemptionHistoryData,
    loading,
  } = useLoyalty();

  useEffect(() => {
    if (dishrackRedemptionStatus) {
      if (dishrackRedemptionStatus?.success) setCode("");
      setAlert();
    }
  }, [dishrackRedemptionStatus]);

  const handleRedemptionFormSubmission = () => {
    redeemDishrackTicket(code, location);
  };

  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <MainHolder activeTheme={mashupBackground}>
        <Children>
          {dishrackRedemptionStatus && (
            <AlertModal
              background={background}
              onClick={() => setDishrackRedemptionsStatus(false)}
              {...dishrackRedemptionStatus}
            />
          )}

          {redeemPage === "redemption-form" && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "40%",
                zIndex: 4,
                background: "rgba(0,0,0,0.8)",
                textAlign: "center",
                padding: "10px",
                boxSizing: "border-box",
              }}
            >
              <form onSubmit={handleRedemptionFormSubmission}>
                <input
                  type='text'
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  style={{
                    fontFamily: "MTNRegular",
                    fontSize: "2.3em",
                    textAlign: "center",
                    marginTop: "40px",
                    color: "#fff",
                    width: "90%",
                    border: "none",
                    boxSizing: "border-box",
                    background: "none",
                  }}
                />
              </form>
            </div>
          )}
          <BackButton
            style={{ zIndex: 5 }}
            onClick={() => {
              if (!redeemPage) {
                history.goBack();
              } else setRedeemPage(false);
            }}
          />
          <FeatureHeader
            image={selectedLoyaltyData?.image}
            title={[selectedLoyaltyData?.title]}
            background={background}
            secondaryBackground={"#fff"}
            description={selectedLoyaltyData?.description}
          />
          <DescriptionBody color={mashupBackground}>
            <CurveHolder>
              <Curve fill={mashupBackground} />
            </CurveHolder>
            <ContentHolder>
              {
                <>
                  {!redeemPage && (
                    <LandingPage
                      setRedeemPage={setRedeemPage}
                      background={background}
                    />
                  )}
                  {(redeemPage === "redemption" ||
                    redeemPage === "redemption-form") && (
                    <RedemptionForm
                      code={code}
                      setCode={setCode}
                      submitForm={() => handleRedemptionFormSubmission()}
                      setRedeemPage={setRedeemPage}
                      redeemDishrackTicket={redeemDishrackTicket}
                      isLoading={loading}
                      location={location}
                      setLocation={setLocation}
                      background={background}
                    />
                  )}
                  {redeemPage === "history" && (
                    <HistoryPage
                      setRedeemPage={setRedeemPage}
                      isLoading={loading}
                      fetchDishrackRedemptionHistory={
                        fetchDishrackRedemptionHistory
                      }
                      dishrackRedemptionHistoryData={
                        dishrackRedemptionHistoryData
                      }
                      background={background}
                    />
                  )}
                </>
              }
            </ContentHolder>
          </DescriptionBody>
        </Children>
      </MainHolder>
    </>
  );
};

const LandingPage = ({ setRedeemPage, background }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <div>
        <ButtonHolder>
          <Button
            onClick={() => setRedeemPage("redemption")}
            style={{
              marginInline: 20,
              height: "40px",
              width: "100%",
              boxSizing: "border-box",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
              display: "flex",
              cursor: "pointer",
            }}
            color={background}
          >
            <StyledText color={"white"}>Redemption</StyledText>
          </Button>
        </ButtonHolder>
      </div>
      <div>
        <ButtonHolder>
          <Button
            onClick={() => {
              setRedeemPage("history");
            }}
            style={{
              marginInline: 20,
              marginBlock: 20,
              height: "40px",
              border: `1px solid ${background}`,
              width: "100%",
              boxSizing: "border-box",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
              display: "flex",
              cursor: "pointer",
            }}
            color={"#fff"}
          >
            <StyledText color={background}>History</StyledText>
          </Button>
        </ButtonHolder>
      </div>
    </div>
  );
};

const RedemptionForm = ({
  setRedeemPage,
  code,
  setCode,
  submitForm,
  isLoading,
  background,
  location,
  setLocation,
}) => {
  const styles = generateStyles();
  const [showForm, setShowForm] = useState(false);
  const notes = [
    'Tap on "Enter redemption code".',
    "Enter offer code",
    "Wait for redemption confirmation!",
  ];

  return (
    <div>
      {showForm ? (
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitForm();
              // setRedeemPage(false);
            }}
          >
            <div style={{ textAlign: "center" }}>
              <p style={{ fontFamily: "MTNBold" }}>Enter redemption code</p>
              <StyledTextInput
                type='text'
                value={code}
                onChange={(e) => setCode(e.target.value?.toUpperCase())}
                placeholder='Enter redemption code'
              />
            </div>
            <div style={{ padding: "0 20px" }}>
              <p
                style={{
                  fontFamily: "MTNBold",
                  marginBottom: "12px",
                  marginTop: "30px",
                }}
              >
                Vendor Location
              </p>
              <div style={{ marginBottom: "7px" }}>
                <CircularRadioInput
                  action={() => setLocation(cinemas.accra)}
                  color={background}
                  label='Accra'
                  checked={location === cinemas.accra}
                />
              </div>
            </div>
            <div>
              <ButtonHolder>
                <Button
                  onClick={() => submitForm()}
                  style={{
                    opacity: isLoading ? "0.5" : "1",
                    marginInline: 20,
                    marginBlock: 20,
                    height: "40px",
                    width: "100%",
                    boxSizing: "border-box",
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "center",
                    display: "flex",
                    cursor: "pointer",
                  }}
                  color={background}
                >
                  <StyledText color={"white"}>
                    {isLoading ? "Processing..." : "Redeem"}
                  </StyledText>
                </Button>
              </ButtonHolder>
            </div>
          </form>
        </>
      ) : (
        <div>
          <ButtonHolder>
            <Button
              onClick={() => {
                setRedeemPage("redemption-form");
                setShowForm(true);
              }}
              style={{
                marginInline: 20,
                height: "40px",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                display: "flex",
                cursor: "pointer",
              }}
              color={background}
            >
              <StyledText color={"white"}>Enter redemption code</StyledText>
            </Button>
          </ButtonHolder>

          <div style={{ textAlign: "left", padding: "20px" }}>
            <StyledText
              size={18}
              fontFamily={"bold"}
            >{`How to redeem`}</StyledText>
            {Array.isArray(notes) &&
              notes.map((item, index) => {
                return (
                  <DescriptionItems key={index}>
                    <CircleContainer>
                      <ColorCircle color={background} />
                    </CircleContainer>
                    <StyledText size={12} style={styles.textStyle}>
                      {item}
                    </StyledText>
                  </DescriptionItems>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

const HistoryPage = ({
  isLoading,
  fetchDishrackRedemptionHistory,
  dishrackRedemptionHistoryData,
}) => {
  useEffect(() => {
    fetchDishrackRedemptionHistory();
  }, []);

  return (
    <div style={{ width: "90%", margin: "0 auto", fontFamily: "MTNRegular" }}>
      <h3>History</h3>
      {isLoading ? (
        "Loading..."
      ) : (
        <div>
          {dishrackRedemptionHistoryData?.success ? (
            <div>
              {dishrackRedemptionHistoryData?.data.length > 0 ? (
                <div>
                  {dishrackRedemptionHistoryData.data.map(
                    ({ _id, ticketCode, msisdn, updatedAt, location }) => {
                      return (
                        <div
                          style={{
                            fontSize: "12px",
                            padding: "10px 0",
                            borderBottom: "1px solid #ddd",
                          }}
                          key={_id}
                        >
                          <div style={{ marginBottom: "5px" }}>
                            Date: {format(new Date(updatedAt), "PPPppp")}
                          </div>
                          <div style={{ marginBottom: "5px" }}>
                            Location: {location || "N/A"}
                          </div>
                          <div style={{ marginBottom: "5px" }}>
                            Redemption code:{" "}
                            <span style={{ fontFamily: "MTNBold" }}>
                              {ticketCode}
                            </span>
                          </div>
                          <div style={{ marginBottom: "5px" }}>
                            Phone: 233*****{msisdn.substr(-4)}
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              ) : (
                <div style={{ color: "#999", textAlign: "center" }}>
                  No redemptions found
                </div>
              )}
            </div>
          ) : (
            <div>{dishrackRedemptionHistoryData?.message}</div>
          )}
        </div>
      )}
    </div>
  );
};

const AlertModal = ({ background, success, message, onClick = () => {} }) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <AlertCurveTop />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "70%",
          top: "22%",
          padding: "10px",
          textAlign: "center",
          boxSizing: "border-box",
        }}
      >
        <AlertIconContainer>
          <div style={{ width: "68px", height: "68px", borderRadius: "50px" }}>
            {success ? (
              <DoneIconNew fill={"#fff"} />
            ) : (
              <div
                style={{
                  color: background,
                  background: "#fff",
                  width: "68px",
                  height: "68px",
                  fontSize: "3em",
                  display: "flex",
                  justifyContent: "center",
                  fontFamily: "MTNBold",
                  alignItems: "center",
                  borderRadius: "50px",
                }}
              >
                <span>!</span>
              </div>
            )}
          </div>
        </AlertIconContainer>

        <h1
          style={{
            fontFamily: "MTNBold",
            fontSize: "1.5em",
            marginTop: "40px",
            marginBottom: "50px",
          }}
        >
          {success ? "Congrats!" : "Sorry!"}
        </h1>
        <p style={{ fontFamily: "MTNRegular" }}>
          {message || "Offer code has been successfully redeemed!"}
        </p>
        <ButtonHolder>
          <Button
            onClick={() => onClick()}
            style={{
              marginInline: 20,
              marginBlock: 20,
              height: "40px",
              width: "40%",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
              display: "flex",
              cursor: "pointer",
            }}
            color={background}
          >
            <StyledText color={"white"}>{success ? "Great!" : "OK"}</StyledText>
          </Button>
        </ButtonHolder>
      </div>
    </div>
  );
};

const CircularRadioInput = ({ action, checked, label, color }) => {
  let height = "10px",
    width = "10px",
    borderWidth = "3px",
    activeColor = "#555",
    dotBackground = "transparent";
  if (checked) {
    activeColor = color;
    dotBackground = color;
  }
  return (
    <div style={{ cursor: "pointer" }}>
      <div
        onClick={() => action()}
        style={{
          display: "inline-block",
          boxSizing: "border-box",
          padding: "2px",
          verticalAlign: "middle",
          border: `${borderWidth} solid ${activeColor}`,
          borderRadius: "24px",
        }}
      >
        <div
          style={{
            height,
            width,
            background: dotBackground,
            borderRadius: "24px",
          }}
        />
      </div>
      <span
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          marginLeft: "10px",
          fontFamily: "MTNRegular",
          color: activeColor,
        }}
        onClick={() => action()}
      >
        {label}
      </span>
    </div>
  );
};

const AlertCurveTop = styled.div`
  position: absolute;
  width: 225%;
  height: 70%;
  top: 30%;
  left: -62%;
  backgroundcolor: "#fff";
  border-top-left-radius: 50%;
  background-color: rgb(255, 255, 255);
  border-top-right-radius: 50%;
`;

const AlertIconContainer = styled.div`
  margin: 0px auto;
  background-color: rgb(245, 130, 30);
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  position: relative;
  z-index: 1;
`;

const ContentHolder = styled.div`
  width: 100%;
  height: auto;
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledTextInput = styled.input`
  padding: 10px;
  outline: none;
  font-family: MTNRegular;
  border: 1px solid #999;
  border-radius: 7px;
  min-width: 200px;
  width: 80%;
  text-align: center;
`;

const DescriptionItems = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
`;

const ColorCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default DishrackRedemptionHome;
